var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "question-item" }, [
    _vm._m(0),
    _c("div", { staticClass: "judge" }, [
      _c(
        "div",
        [
          _c(
            "el-radio-group",
            {
              attrs: { disabled: _vm.readOnly },
              model: {
                value: _vm.checkOption,
                callback: function ($$v) {
                  _vm.checkOption = $$v
                },
                expression: "checkOption",
              },
            },
            _vm._l(_vm.options, function (item) {
              return _c(
                "el-radio",
                {
                  key: item["exam_questions_options.name"],
                  attrs: {
                    label: item["exam_questions_options.name"],
                    border: "",
                  },
                  on: { change: _vm.changeOption },
                },
                [_vm._v(" " + _vm._s(item["exam_questions_options.name"]))]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-box" }, [
      _c("span", { staticClass: "line-name" }, [_vm._v("选项")]),
      _c("span", { staticClass: "line-dec" }, [
        _vm._v("请选择正确或错误（默认正确）"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }